<template>
    <static-search-link v-if="!freeAgency" 
        :to="personalPageURL" 
        :shouldEmit="true"
        @clickCallback="(to) => loadPersonalPage(to)"
        ><slot></slot>
    </static-search-link>
    <template v-else><slot></slot></template>
</template>

<script>

import StaticSearchLink from './StaticSearchLink.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: "PersonalPageLink",
    components: {
        StaticSearchLink
    },
    props: {
        agency: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    methods: {
        loadPersonalPage(to) {
            // for future me, this returns { path: string, query: URLSearchParams }
            let url = this.url_to_object(to);
            url.query.set('search_id', this.searchId);
            this.link_to(url);
            // alert("unpacked: " + this.unpack_url(url));
        }
    },
    computed: {
        ...mapState('search', ['parameters', 'searchId']),
        ...mapGetters('search', ['makePersonalPageURL']),
        freeAgency() {
            return (this.agency.FAL) ? true : false;
        },
        personalPageURL () {
            return this.makePersonalPageURL(this.agency);
        },
    }
}
</script>
